<template>
    <list-page icone="mdi-format-list-numbered-rtl" titulo="Fluxo Bancário (Extrato)" @novo="Novo()" @atualizar="Carregar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :sort-by.sync="options.sortBy" :options.sync="options" :server-items-length="totalLista" :loading="loading" multi-sort class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

            <template v-slot:[`item.dataInicial`]="{ item }">
              {{new Date(item.dataInicial).ddmmyyyy()}}
            </template>

            <template v-slot:[`item.dataFinal`]="{ item }">
              {{new Date(item.dataFinal).ddmmyyyy()}}
            </template>

            <template v-slot:[`item.documento`]="{ item }">
              <a @click="Download(item)">{{ item.documento }}</a>
            </template>

          </v-data-table>
          

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.projeto.codigoNome }}</td>
                    <td>{{ item.banco.nome }}</td>
                    <td>{{ new Date(item.dataInicial).ddmmyyyy() }}</td>
                    <td>{{ new Date(item.dataFinal).ddmmyyyy() }}</td>
                    <td> <a @click="Download(item)">{{ item.documento }}</a></td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-fluxobancario-extrato v-model="dialogCadastro" :item="item" @fechou="FechouCadastro()"/>

        </template>
    </list-page>
</template>

<script>
import {FluxoBancarioExtratoService} from '@/core/services/projetos/monitoramento';
import {FluxoBancarioExtrato} from '@/core/domain/projetos/monitoramento';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false  },
        { text: 'Projeto', value: 'projeto.nome' },
        { text: 'Banco', value: 'banco.nome' },
        { text: 'Inicial', value: 'dataInicial', type: 'date' },
        { text: 'Final', value: 'dataFinal', type: 'date' },
        { text: 'Documento', value: 'documento' },
      ],
      primeiraCarga: true
    }),
    created() {
      this.service = new FluxoBancarioExtratoService();
      this.include = "Projeto, Banco";
      this.options.sortBy = ['projeto.nome'];
    },
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    methods: {
      Novo(){
        this.NovoCadastro(new FluxoBancarioExtrato());
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Projeto, Banco")
          .then(
            res =>{
              this.EditarCadastro(new FluxoBancarioExtrato(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      },
      Download(item){
        this.service.DownloadDocumento(item.id, item.documento);
      },
      FechouCadastro(){
        this.dialogCadastro = false;
        this.Carregar();
      },
      Carregar(){
        this.Listar(null, "Projeto, Banco");
      }
    }
}
</script>